var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SetPopup',{ref:"confirm"}),(_vm.formReady)?_c('MaterialIndexForm',{attrs:{"param":_vm.param,"title":_vm.title,"is-edit":_vm.isEdit,"save-label":"저장"},on:{"save":_vm.save,"cancel":_vm.cancle}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }